import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { throwError } from 'rxjs/internal/observable/throwError';
import { environment } from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class JobLogService {

  constructor( private readonly http  : HttpClient) { }

  baseURL = environment.baseAPIURL;
  
  getJobLog(jobId:any)
  {
    return this.http.get(`${this.baseURL}/aetImport/getAetFtpFileImport/getLogs/${jobId}`).pipe(catchError(this.handleError) )
  }

  private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}
